export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-thumb-4dfa39b5c40a07fde2bf8322600e8909.png";